<ng-container *finLet="template$ | finMap: 'loading' | async as isLoading">
  <fin-loader *ngIf="isLoading" [type]="LoaderType.INLINE"></fin-loader>

  <ng-container *ngIf="!isLoading">
    <fin-mmb-entry-widget
      *ngIf="(template$ | finMap: 'data.status' | async) !== 404"
      [backgroundImage]="backgroundImage$ | async"
      [tourOperatorImage]="tourOperatorImage$ | async"
      [operator]="operator$ | async"
      [loading]="loading$ | async"
      [disruptions$]="disruptions$"
    >
    </fin-mmb-entry-widget>

    <fin-cms-json-content
      class="grid-max-width grid-col-12 no-row-gap"
      *ngIf="mainContent$ | async"
      [template$]="mainContent$"
    >
    </fin-cms-json-content>
  </ng-container>
</ng-container>
